import Request from './request';

async function createUser(data) {
  return Request('post', 'api/lakala-interface/create-user', data)
}

async function createUserForBalance(data) {
  return Request('post', 'api/lakala-interface/create-user-for-balance', data)
}

async function queryBalance(data) {
  return Request('get', 'api/lakala-interface/queryBalance', data)
}

async function queryCard(data) {
  return Request('get', 'api/lakala-interface/queryCard', data)
}

async function bandCard(data) {
  return Request('post', 'api/lakala-interface/band-card', data)
}

async function cash(data) {
  return Request('post', 'api/lakala-interface/cash', data)
}

async function balancePay(data) {
  return Request('post', 'api/lakala-interface/balance-pay', data)
}

async function enchashment(data) {
  return Request('post', 'api/lakala-interface/cash-for-balance', data)
}

async function balanceReturn(data) {
  return Request('post', 'api/lakala-interface/balance-return', data)
}


export default {
  createUser,
  createUserForBalance,
  queryBalance,
  queryCard,
  bandCard,
  cash,
  balancePay,
  enchashment,
  balanceReturn,
};